export enum Scope {
  AlertsSearch = 'agt:alert:search',
  BulkAddExclusiveAgents = 'agt:agentusers:bulkaddexclusiveagents',
  BulkAddFieldLeaders = 'agt:agentusers:bulkaddfieldleaders',
  BulkAddFieldVicePresidents = 'agt:agentusers:bulkaddfieldvicepresidents',
  BulkAddIndependentAgents = 'agt:agentusers:bulkaddindependent',
  BulkAddVips = 'agt:agentusers:bulkaddvips',
  ClaimSearch = 'agt:claim:search',
  CommissionSearch = 'agt:commission:search',
  CreateAgencyAdministrator = 'agt:agentusers:createagencyadministrator',
  EditExclusiveAgents = 'prt:users:exclusive:edit',
  PolicySearch = 'agt:policy:search',
  SearchExclusiveAgents = 'prt:users:exclusive:search',
  SearchIndependentAgents = 'agt:users:search:independent',
  AgentUsersSearch = 'prt:users:agent:search',
  UserDelete = 'prt:users:delete',
  ResetUserWithTemporaryPass = 'prt:users:resetpassword',
  AllAppSSO = 'agt:sso:allapp',
  AgentResources = 'agt:resources:access',
  AgentLicense = 'agt:license:search',
  BeneficiariesAdd = 'ben:add',
  SubscriptionsSearch = 'subscriptions:search',
  AddBeneficiariesUser = 'prt:users:beneficiaries:add',
  AddBOSToolsUser = 'prt:users:businessoperationsupport:add',
  // *************************************
  SearchTaxStatements = 'agt:1099:search',
  EditAgency = 'agt:agency:association:edit',
  SearchAgentUsers = 'agt:agents:search',
  SearchAgentUsersByExternalExclusivityStatus = 'agt:agents:search:exclusivitystatus:external',
  SearchAgentUsersByInternalExclusivityStatus = 'agt:agents:search:exclusivitystatus:internal',
  SearchAgentUsersByRecruiterCode = 'agt:agents:search:recruitercode',
  SearchAgentUsersByIdentifier = 'agt:agents:search:identifier',
  SearchAgentUsersByRecruiterCodes = 'agt:agents:search:fieldsalesleader:recruitercode',
  SearchAgentUsersByLocation = 'agt:agents:search:location',
  SearchPortalUsers = 'prt:users:search',
  AddFieldSalesLeader = 'prt:users:fieldsalesleader:add',
  AddFieldVicePresident = 'prt:users:fieldvicepresident:add',
  AddVip = 'prt:users:vip:add',
  EditUser = 'prt:users:edit',
  EditVip = 'prt:users:vip:edit',
  EditFieldSalesLeader = 'prt:users:fieldsalesleader:edit',
  EditFieldVicePresident = 'prt:users:fieldvicepresident:edit',
  AddExclusiveAgent = 'prt:users:exclusive:add',
  AddSupportAgent = 'prt:users:support:add',
  EditExclusiveAgent = 'prt:users:exclusive:edit',
  ViewFieldVicePresidents = 'prt:users:fieldsalesleaders:read',
  AssignFieldSalesLeaderToFieldVicePresident = 'prt:users:fieldsalesleaders:assign',
  UploadAgents = 'prt:users:agents:add:bulk',
  UploadExclusiveAgents = 'prt:users:exclusiveagents:add:bulk',
  UploadIndependentAgents = 'agt:independent:add:bulk',
  UploadFieldVicePresidents = 'prt:users:fieldvicepresidents:add:bulk',
  UploadVips = 'prt:users:vips:add:bulk',
  UploadFieldSalesLeaders = 'prt:users:fieldleaders:add:bulk',
  UploadIndependentAgentsByAgency = 'agt:agency:independent:add:bulk',
  UploadMessagingUser = 'prt:users:messaging:add:bulk',
  AddIndependentAgentPreregistration = 'agt:users:preregister:add',
  AddIndependentAgentWithAllAgencies = 'agt:agency:users:preregister:add',
  AddIndependentAgentPreregistrationToAgency = 'agt:external:users:preregister:add',
  ValidateInternalUser = 'prt:users:validate',
  ValidateExternalUser = 'agt:profile:validate',
  LinkIndependentAgent = 'agt:users:independent:link',
  SearchRecruiterCodes = 'prt:agt:recruitercodes:read',
  SsoAccess = 'agt:sso:access',
  ImpersonateAgent = 'agt:impersonate',
  ImpersonateAgentLocation = 'agt:impersonate:Location',
  ViewUserDetails = 'prt:users:details:read',
  ViewAgentDetails = 'agt:users:details:read',
  UpdateProfile = 'agt:profile:edit',
  ValidateTaxId = 'agt:identifier:validate',
  SearchAccounts = 'agt:account:search',
  ViewAccountBilling = 'agt:account:billing:read',
  ViewAccountDetails = 'agt:account:read',
  UploadEnrollmentApplication = 'agt:account:application:upload',
  SearchPolicyReports = 'agt:account:report:policy:information',
  SearchPolicies = 'agt:policy:search',
  ViewPolicy = 'agt:policy:read',
  EditAnyAgent = 'shared:agent:edit',
  SearchClaims = 'agt:claims:search',
  ViewClaim = 'agt:claims:read',
  SearchCommissions = 'agt:commission:search',
  SearchPolicyCorrespondence = 'agt:policy:correspondence:search',
  ViewCorrespondenceDetails = 'agt:policy:correspondence:read',
  UploadPolicyDocument = 'agt:policy:document:upload',
  ViewPolicyImges = 'agt:policy:image:read',
  SearchEnrollmentApplications = 'agt:policy:application:search',
  SendServiceRequest = 'agt:policy:serviceRequest:email',
  AgencyAdministrator = 'agt:agency:admin',
  ViewAgentHierarchy = 'agt:hierarchy:read',
  SearchCommissionSchedules = 'agt:commission:schedule:search',
  ViewCommissionSchedules = 'agt:commission:schedule:read',
  AgentNewsAdministration = 'agt:news:write',
  ViewAgentNews = 'agt:news:read',
  BOSTools = 'bos:tools:access|*',
  ViewMessages = 'ms:read',
  SendMessages = 'ms:send',
  ReceiveMessages = 'ms:subscribe',
  AddMessagingUser = 'prt:users:add|6',
  ViewPendingUnderwritingRequirements = 'agt:underwritingrequirements:read',
  ViewAccountImages = 'agt:account:image:read',
  AddUser = 'prt:users:add',
  UpdateUser = 'prt:users:update',
  DeleteUser = 'prt:users:delete',
  AddPreregistrationUsers = 'prt:users:preregister:add',
  SearchPreregistrationUsers = 'prt:users:preregister:search',
  SendRegistrationEmail = 'prt:users:preregister:email:send',
  DeletePreregistrationUser = 'prt:users:preregister:delete',
  AgentSearchCustomerSupport = 'cs:agent:user:search|2',
}

export const TerminatedAgentScopes = [Scope.SearchTaxStatements, Scope.SearchCommissions];
